import { LineString, Point, Polygon } from "geojson";
import { LngLat } from "react-map-gl/maplibre";

export function convertPolygonToGeometry(polygon: LngLat[]): Polygon {
  return {
    type: "Polygon",
    coordinates: [polygon.map((point) => [point.lng, point.lat])],
  };
}

export function convertLineToGeometry(line: LngLat[]): LineString {
  return {
    type: "LineString",
    coordinates: line.map((point) => [point.lng, point.lat]),
  };
}

export function convertPointToGeometry(point: LngLat): Point {
  return {
    type: "Point",
    coordinates: [point.lng, point.lat],
  };
}
